import { useEffect, useState } from 'react';
import ServicePresesnter from './ServicePresesnter';
import { HeaderMenuList } from '../../assets/datas/ConstantLists';
import { useLocation } from 'react-router-dom';

const ServiceContainer = () => {
  const location = useLocation();
  const dataList = HeaderMenuList.find(menu => menu.path === "service").children;

  // const [serviceType, setServiceType] = useState<string>(window.location.hash ? window.location.hash.split("#")[1] : dataList[0].path);
  const [serviceType, setServiceType] = useState<string>(location.state?.type || dataList[0].path);

  const _setServiceType = (path: string) => {
    setServiceType(path);
  };

  useEffect(() => {
    if(location.state)
      setServiceType(location.state?.type || dataList[0].path);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.state]);

  useEffect(() => {
    // const path = window.location.hash?.split("#")[1];
    // if(path) {
    //   setServiceType(path);
    // }
  }, []);

  return (
    <ServicePresesnter 
      dataList={dataList}
      _setServiceType={_setServiceType}
      serviceType={serviceType}
    />
  );
};
export default ServiceContainer;
